module.exports = __webpack_public_path__ + "img/natureStamp.da609885.svg";